import { useContext, useEffect, useState } from 'react';
import { Option } from 'components/interfaces/GeneralInterface';
import { GlobalContext } from 'pages/_app';
import { getTranslation, useTranslation } from 'utils/localization';
import { getCountriesList } from 'services/list.service';
import { TNamespaceEnum } from 'types/types';

export const useCountriesList = (load = true, reload = false): Option[] => {
    const { t } = useTranslation();
    const [countriesList, setCountriesList] = useState<Option[]>([]);
    const { lang } = useContext(GlobalContext);

    useEffect(() => {
        if (load && (!countriesList.length || reload)) {
            getCountriesList().then((r) => {
                const list = [
                    {
                        value: 'CZ',
                        label: getTranslation(
                            t,
                            TNamespaceEnum.countries,
                            'CZ'
                        ),
                    },
                    ...r.data.values
                        .map((item) => ({
                            value: item.name,
                            label: getTranslation(
                                t,
                                TNamespaceEnum.countries,
                                item.name
                            ),
                        }))
                        .filter((a) => a.value !== 'CZ')
                        .sort((a, b) => a.label.localeCompare(b.label)),
                ];
                setCountriesList(list);
            });
        }
    }, [load, reload]);

    useEffect(() => {
        const list = countriesList.map((option) => ({
            value: option.value,
            label: getTranslation(
                t,
                TNamespaceEnum.countries,
                option.value.toString()
            ),
        }));
        setCountriesList(list);
    }, [lang]);

    return countriesList;
};
